<template>
	<v-dialog v-model="visible" max-width="750" persistent>
		<v-card>
			<div class="d-flex justify-space-between align-center">
				<h1 v-if="mode === 'edit'">Sub Task zosynchronizovaný z Office365 sa nedá upravovat. Upravte ho vo svojom kalendári a pockajte na zosynchronizovanie s Task Managerom</h1>
				<h1 v-else-if="mode === 'delete'">Sub Task zosynchronizovaný z Office365 sa nedá zmazať. Zmažte ho vo svojom kalendári a pockajte na zosynchronizovanie s Task Managerom</h1>

				<v-icon
					@click.stop="closeModal()"
					icon="mdi-close"
					size="large"
				></v-icon>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import modalMixin from '@/plugins/tm@modal/_mixins/modal.mixin'

export default {
	mixins: [ modalMixin ],
	emits: ['close', 'on-subtask-edited'],

	props: {
		mode: {
			type: String,
			default: 'edit' // edit or delete
		}
	},

	data() {
		return {
			visible: false,
			subtask: null
		}
	},

	methods: {
		async showModal({ subtask }) {
			this.subtask = subtask
			this.visible = true
		},

		async complete() {
			console.log('complete')
		},

		closeModal() {
			this.visible = false
		}
	}
}
</script>